import React from 'react';
import { useNavigate } from 'react-router-dom';
import { 
    FaArrowLeft, 
    FaGlobeAmericas, 
    FaGavel, 
    FaCalculator, 
    FaFileDownload, 
    FaGraduationCap,
    FaExternalLinkAlt,
    FaCheckCircle
} from 'react-icons/fa';

// Plantilla base para subcategorías
const RecursoSubcategoryTemplate = ({ 
    title, 
    description, 
    icon: Icon, 
    color, 
    recursos, 
    onBack 
}) => {
    return (
        <div className="subcategory-page">
            <div className="subcategory-header">
               
                <div className="subcategory-info">
                    <div className="category-icon" style={{ backgroundColor: color }}>
                        <Icon />
                    </div>
                    <div className="category-text">
                        <h1>{title}</h1>
                        <p>{description}</p>
                    </div>
                </div>
            </div>

            <div className="resources-list">
                {recursos.map((recurso, index) => (
                    <div key={index} className="resource-item">
                        <div className="resource-content">
                            <div className="resource-header">
                                <h3 className="resource-title">{recurso.title}</h3>
                                {recurso.isOfficial && (
                                    <span className="official-badge">
                                        <FaCheckCircle />
                                        Oficial
                                    </span>
                                )}
                            </div>
                            <p className="resource-description">{recurso.description}</p>
                            {recurso.tags && (
                                <div className="resource-tags">
                                    {recurso.tags.map(tag => (
                                        <span key={tag} className="tag">#{tag}</span>
                                    ))}
                                </div>
                            )}
                        </div>
                        <div className="resource-actions">
                            <a
                                href={recurso.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="visit-btn"
                            >
                                <FaExternalLinkAlt />
                                Visitar
                            </a>
                        </div>
                    </div>
                ))}
            </div>

            <style jsx>{`
                .subcategory-page {
                    min-height: 100vh;
                    background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);
                    padding: 2rem;
                }

                .subcategory-header {
                    max-width: 1000px;
                    margin: 0 auto 2rem auto;
                }

                .back-btn {
                    background: rgba(255, 255, 255, 0.9);
                    border: none;
                    padding: 0.75rem 1.5rem;
                    border-radius: 8px;
                    color: #1e293b;
                    font-weight: 600;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    gap: 0.5rem;
                    margin-bottom: 2rem;
                    transition: all 0.3s ease;
                }

                .back-btn:hover {
                    background: white;
                    transform: translateY(-2px);
                }

                .subcategory-info {
                    background: white;
                    padding: 2rem;
                    border-radius: 16px;
                    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
                    display: flex;
                    align-items: center;
                    gap: 1.5rem;
                }

                .category-icon {
                    width: 80px;
                    height: 80px;
                    border-radius: 20px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: white;
                    font-size: 2rem;
                    flex-shrink: 0;
                }

                .category-text h1 {
                    color: #1e293b;
                    font-size: 2rem;
                    font-weight: 700;
                    margin: 0 0 0.5rem 0;
                }

                .category-text p {
                    color: #64748b;
                    font-size: 1.1rem;
                    margin: 0;
                    line-height: 1.5;
                }

                .resources-list {
                    max-width: 1000px;
                    margin: 0 auto;
                    display: flex;
                    flex-direction: column;
                    gap: 1.5rem;
                }

                .resource-item {
                    background: white;
                    border-radius: 12px;
                    padding: 2rem;
                    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    gap: 2rem;
                    transition: all 0.3s ease;
                }

                .resource-item:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 8px 12px -1px rgba(0, 0, 0, 0.15);
                }

                .resource-content {
                    flex: 1;
                }

                .resource-header {
                    display: flex;
                    align-items: center;
                    gap: 1rem;
                    margin-bottom: 0.75rem;
                    flex-wrap: wrap;
                }

                .resource-title {
                    color: #1e293b;
                    font-size: 1.25rem;
                    font-weight: 700;
                    margin: 0;
                    line-height: 1.4;
                }

                .official-badge {
                    display: flex;
                    align-items: center;
                    gap: 0.25rem;
                    background: #10b981;
                    color: white;
                    padding: 0.25rem 0.75rem;
                    border-radius: 12px;
                    font-size: 0.75rem;
                    font-weight: 600;
                }

                .resource-description {
                    color: #64748b;
                    line-height: 1.6;
                    margin: 0 0 1rem 0;
                }

                .resource-tags {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 0.5rem;
                }

                .tag {
                    background: #f1f5f9;
                    color: #475569;
                    font-size: 0.75rem;
                    font-weight: 500;
                    padding: 0.25rem 0.75rem;
                    border-radius: 12px;
                    border: 1px solid #e2e8f0;
                }

                .resource-actions {
                    flex-shrink: 0;
                }

                .visit-btn {
                    background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);
                    color: white;
                    padding: 1rem 2rem;
                    border-radius: 10px;
                    text-decoration: none;
                    font-weight: 600;
                    display: flex;
                    align-items: center;
                    gap: 0.75rem;
                    transition: all 0.3s ease;
                    box-shadow: 0 4px 6px -1px rgba(139, 92, 246, 0.3);
                }

                .visit-btn:hover {
                    background: linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%);
                    transform: translateY(-2px);
                    box-shadow: 0 8px 15px -3px rgba(139, 92, 246, 0.4);
                    text-decoration: none;
                    color: white;
                }

                @media (max-width: 768px) {
                    .subcategory-page {
                        padding: 1rem;
                    }

                    .subcategory-info {
                        flex-direction: column;
                        text-align: center;
                        padding: 1.5rem;
                    }

                    .category-text h1 {
                        font-size: 1.5rem;
                    }

                    .resource-item {
                        flex-direction: column;
                        align-items: stretch;
                        gap: 1.5rem;
                        padding: 1.5rem;
                    }

                    .resource-header {
                        justify-content: center;
                        text-align: center;
                    }

                    .visit-btn {
                        justify-content: center;
                        width: 100%;
                    }
                }
            `}</style>
        </div>
    );
};

// Componentes específicos para cada subcategoría

export const SitiosOficiales = () => {
    const navigate = useNavigate();

    const recursos = [
        {
            title: "Portal de contratos menores a 8 UIT",
            description: "Portal oficial para consultar procesos menores",
            url: "https://prod6.seace.gob.pe/auth-proveedor/",
            isOfficial: true,
            tags: ["Contratos menores", "procesos", "pladicop", "oficial"],
        },
        {
            title: "SEACE - Sistema Electrónico de Contrataciones del Estado",
            description: "Portal oficial de búsqueda de convocatorias",
            url: "https://prod2.seace.gob.pe/seacebus-uiwd-pub/buscadorPublico/buscadorPublico.xhtml",
            isOfficial: true,
           tags: ["OECE", "SEACE", "consultas", "oficial"],
        },
        {
            title: "PAC - Plan Anual de Contrataciones",
            description: "Portal oficial del Plan anual de contrataciones",
            url: "https://prod2.seace.gob.pe/pac3-publico/pages/buscadorPPpublico.xhtml",
  isOfficial: true,
            tags: ["PAC", "proveedores", "OECE", "oficial"],
           
        }
    ];

    return (
        <RecursoSubcategoryTemplate
            title="Sitios Oficiales"
            description="Portales gubernamentales oficiales para contrataciones públicas"
            icon={FaGlobeAmericas}
            color="#3b82f6"
            recursos={recursos}
            onBack={() => navigate('/recursos')}
        />
    );
};

export const MarcoLegal = () => {
    const navigate = useNavigate();
    
    const recursos = [
        {
            title: "Ley de Contrataciones del Estado - Ley N° 30225",
            description: "Texto completo y actualizado de la Ley de Contrataciones del Estado. Incluye todas las modificatorias y disposiciones vigentes.",
            url: "https://busquedas.elperuano.pe/dispositivo/NL/30225",
            isOfficial: true,
            tags: ["ley", "contrataciones", "30225", "marco legal"]
        },
        {
            title: "Reglamento de la Ley de Contrataciones - DS N° 344-2018-EF",
            description: "Reglamento completo de la Ley de Contrataciones del Estado con todas las modificaciones vigentes.",
            url: "https://busquedas.elperuano.pe/dispositivo/NL/344-2018-EF",
            isOfficial: true,
            tags: ["reglamento", "DS", "344-2018-EF", "procedimientos"]
        },
        {
            title: "Directivas OSCE",
            description: "Colección completa de todas las directivas emitidas por OSCE para la aplicación de la normativa de contrataciones.",
            url: "https://www.osce.gob.pe/normativa/directivas/",
            isOfficial: true,
            tags: ["directivas", "OSCE", "procedimientos", "aplicación"]
        },
        {
            title: "Jurisprudencia de Opiniones OSCE",
            description: "Base de datos completa de opiniones del OSCE sobre consultas en materia de contratación pública.",
            url: "https://www.osce.gob.pe/jurisprudencia-y-normativa/jurisprudencia/",
            isOfficial: true,
            tags: ["jurisprudencia", "opiniones", "consultas", "casos"]
        },
        {
            title: "Texto Único de Procedimientos Administrativos - TUPA OSCE",
            description: "TUPA del OSCE con todos los procedimientos administrativos y sus requisitos actualizados.",
            url: "https://www.osce.gob.pe/transparencia/tupa/",
            isOfficial: true,
            tags: ["TUPA", "procedimientos", "requisitos", "trámites"]
        }
    ];

    return (
        <RecursoSubcategoryTemplate
            title="Marco Legal"
            description="Leyes, reglamentos y normativas de contratación pública"
            icon={FaGavel}
            color="#dc2626"
            recursos={recursos}
            onBack={() => navigate('/recursos')}
        />
    );
};

export const HerramientasCalculo = () => {
    const navigate = useNavigate();
    
    const recursos = [
        {
            title: "Calculadora de UIT - SUNAT",
            description: "Valor actualizado de la Unidad Impositiva Tributaria (UIT) y calculadora automática para diferentes años.",
            url: "https://www.sunat.gob.pe/indicestasas/uit.html",
            isOfficial: true,
            tags: ["UIT", "calculadora", "SUNAT", "valores tributarios"]
        },
        {
            title: "Índices Unificados de Precios - INEI",
            description: "Índices oficiales para reajustes de precios en contratos de construcción y otros sectores.",
            url: "https://www.inei.gob.pe/estadisticas/indice-tematico/construction/",
            isOfficial: true,
            tags: ["INEI", "índices", "construcción", "reajustes"]
        },
        {
            title: "Tipo de Cambio - BCRP",
            description: "Tipos de cambio oficiales del Banco Central de Reserva del Perú para operaciones contractuales.",
            url: "https://www.bcrp.gob.pe/estadisticas/tipo-de-cambio-de-monedas.html",
            isOfficial: true,
            tags: ["BCRP", "tipo de cambio", "monedas", "conversión"]
        },
        {
            title: "Calculadora de Penalidades - OSCE",
            description: "Herramienta para el cálculo de penalidades por retraso en la ejecución contractual.",
            url: "https://www.osce.gob.pe/calculadora-penalidades/",
            isOfficial: true,
            tags: ["penalidades", "retrasos", "cálculo", "contractual"]
        },
        {
            title: "Simulador de Procesos - SEACE",
            description: "Herramienta de simulación para calcular cronogramas y etapas de procesos de selección.",
            url: "https://www.seace.gob.pe/simulador/",
            isOfficial: true,
            tags: ["simulador", "cronogramas", "procesos", "plazos"]
        }
    ]

};

export const FormatosPlantillas = () => {
    const navigate = useNavigate();
    
    const recursos = [
        {
            title: "Documentos Estándar de Licitación Pública",
            description: "Paquete completo de formatos oficiales para procesos de licitación pública, incluyendo bases integradas y anexos.",
            url: "https://www.osce.gob.pe/documentos-estandar/licitacion-publica/",
            isOfficial: true,
            tags: ["licitación pública", "documentos estándar", "bases", "anexos"]
        },
        {
            title: "Documentos Estándar de Concurso Público",
            description: "Formatos oficiales para procesos de concurso público de servicios, consultorías y otros.",
            url: "https://www.osce.gob.pe/documentos-estandar/concurso-publico/",
            isOfficial: true,
            tags: ["concurso público", "servicios", "consultorías", "formatos"]
        },
        {
            title: "Formatos de Adjudicación Menor",
            description: "Plantillas y formatos para procesos de adjudicación menor de bienes, servicios y obras.",
            url: "https://www.osce.gob.pe/documentos-estandar/adjudicacion-menor/",
            isOfficial: true,
            tags: ["adjudicación menor", "bienes", "servicios", "obras"]
        },
        {
            title: "Plantillas de Contratos",
            description: "Modelos de contratos para diferentes tipos de procesos y modalidades de contratación.",
            url: "https://www.osce.gob.pe/documentos-estandar/contratos/",
            isOfficial: true,
            tags: ["contratos", "modelos", "modalidades", "plantillas"]
        },
        {
            title: "Formatos de Garantías",
            description: "Modelos de cartas fianza y garantías para los diferentes procesos de contratación pública.",
            url: "https://www.osce.gob.pe/documentos-estandar/garantias/",
            isOfficial: true,
            tags: ["garantías", "cartas fianza", "formatos", "respaldos"]
        }
    ];

    return (
        <RecursoSubcategoryTemplate
            title="Formatos y Plantillas"
            description="Documentos y plantillas oficiales descargables"
            icon={FaFileDownload}
            color="#7c3aed"
            recursos={recursos}
            onBack={() => navigate('/recursos')}
        />
    );
};

export const Capacitacion = () => {
    const navigate = useNavigate();
    
    const recursos = [
        {
            title: "Campus Virtual OSCE",
            description: "Plataforma oficial de capacitación virtual del OSCE con cursos gratuitos y de especialización en contrataciones públicas.",
            url: "https://campus.osce.gob.pe/",
            isOfficial: true,
            tags: ["capacitación virtual", "cursos", "especialización", "gratuito"]
        },
        {
            title: "Programa de Certificación OSCE",
            description: "Programa integral de certificación profesional en contrataciones del Estado con diferentes niveles.",
            url: "https://www.osce.gob.pe/certificacion/",
            isOfficial: true,
            tags: ["certificación", "profesional", "niveles", "acreditación"]
        },
        {
            title: "Webinars y Conferencias",
            description: "Archivo de webinars, conferencias magistrales y eventos de capacitación especializados.",
            url: "https://www.osce.gob.pe/capacitacion/webinars/",
            isOfficial: true,
            tags: ["webinars", "conferencias", "eventos", "especialización"]
        },
        {
            title: "Material de Estudio",
            description: "Biblioteca digital con guías, manuales, casos prácticos y material de estudio actualizado.",
            url: "https://www.osce.gob.pe/capacitacion/biblioteca/",
            isOfficial: true,
            tags: ["biblioteca", "manuales", "guías", "casos prácticos"]
        },
        {
            title: "Cursos Presenciales",
            description: "Información sobre cursos presenciales, talleres especializados y programas de capacitación in situ.",
            url: "https://www.osce.gob.pe/capacitacion/presencial/",
            isOfficial: true,
            tags: ["presencial", "talleres", "in situ", "especialización"]
        }
    ];

    return (
        <RecursoSubcategoryTemplate
            title="Capacitación"
            description="Cursos y material de capacitación en contrataciones"
            icon={FaGraduationCap}
            color="#0891b2"
            recursos={recursos}
            onBack={() => navigate('/recursos')}
        />
    );
};